import secureLocalStorage from "react-secure-storage";
import { filterBy, orderBy } from "@progress/kendo-data-query";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import React, { PureComponent } from "react";
import "../../Styles/RiskViews.scss";
import CurrencyFormat from "../Tenant/Component/CurrencyFormat";
import { formatNumber } from "@telerik/kendo-intl";
import * as moment from "moment";

import ColumnMenuFilterForTask from "./ColumnMenuFilterForTask";
import { ColumnMenuCheckboxFilter } from "../Dashboard/ColumnMenuCheckboxFilter";
import { CustomFieldSearchMenuForAction } from "../Dashboard/CustomFieldSearchMenuForAction";
import Api from "../../Services/Api";
import { CircularProgress } from "@material-ui/core";
import TaskProjectedComDate from "./TaskProjectedComDate";
import TaskOriginalCompDate from "./TaskOriginalCompDate";
import { Popup } from "@progress/kendo-react-popup";

const filterOperators= {
  'text': [
      { text: 'grid.filterContainsOperator', operator: 'contains' },
      { text: 'grid.filterNotContainsOperator', operator: 'doesnotcontain' },
      { text: 'grid.filterEqOperator', operator: 'eq' },
      { text: 'grid.filterNotEqOperator', operator: 'neq' },
      { text: 'grid.filterStartsWithOperator', operator: 'startswith' },
      { text: 'grid.filterEndsWithOperator', operator: 'endswith' },
      { text: 'grid.filterIsNullOperator', operator: 'isnull' },
      { text: 'grid.filterIsNotNullOperator', operator: 'isnotnull' },
      // { text: 'grid.filterIsEmptyOperator', operator: 'isempty' },
      // { text: 'grid.filterIsNotEmptyOperator', operator: 'isnotempty' }
  ],
  'numeric': [
      { text: 'grid.filterEqOperator', operator: 'eq' },
      { text: 'grid.filterNotEqOperator', operator: 'neq' },
      { text: 'grid.filterGteOperator', operator: 'gte' },
      { text: 'grid.filterGtOperator', operator: 'gt' },
      { text: 'grid.filterLteOperator', operator: 'lte' },
      { text: 'grid.filterLtOperator', operator: 'lt' },
      { text: 'grid.filterIsNullOperator', operator: 'isnull' },
      { text: 'grid.filterIsNotNullOperator', operator: 'isnotnull' }
  ],
  'date': [
      { text: 'grid.filterEqOperator', operator: 'eq' },
      { text: 'grid.filterNotEqOperator', operator: 'neq' },
      { text: 'grid.filterAfterOrEqualOperator', operator: 'gte' },
      { text: 'grid.filterAfterOperator', operator: 'gt' },
      { text: 'grid.filterBeforeOperator', operator: 'lt' },
      { text: 'grid.filterBeforeOrEqualOperator', operator: 'lte' },
      { text: 'grid.filterIsNullOperator', operator: 'isnull' },
      { text: 'grid.filterIsNotNullOperator', operator: 'isnotnull' }
  ],
  'boolean': [
      { text: 'grid.filterEqOperator', operator: 'eq' },
  ]
}
export default class SubTaskDataset extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      sort: [],
      take: 10,//Math.round((window.innerHeight - 250) / 35),
      skip: 0,
      taskDataList: [],
      customFieldsmaster: [],
      riskTypemaster: [],
      taskDataListTemp: [],
      impactMaster: [],
      selectedIds: [],
      existingFilter: [],
      // dropdownColumns:[],
      selectedColumn: undefined,
      filter: {
        logic: "and",
        filters: [],
      },
      sort: [],
      actionProgressComments:[],
      progressStatusFlag:false
    };
    Date.prototype.toJSON = function () {
      return moment(this).format("YYYY-MM-DDTHH:mm:ss");
    };
  }

  // componentDidUpdate(prevProps) {
  //   if (this.props.taskDataList !== prevProps.taskDataList) {
  //     this.initSubTasks(this.props.taskDataList);
  //   }
  //   Date.prototype.toJSON = function () {
  //     return moment(this).format("YYYY-MM-DDTHH:mm:ss");
  //   };
  // }
//Trigger By parents
  initSubTasks = async (taskActions) => {

    await this.createDynamicDropdowns(taskActions,[],"INIT");
    this.setState({
      ...this.state,
      sort: [],
      filter: {
        logic: "and",
        filters: [],
      },
    });
  };

  //trigger method by parent
  updateFilter = () => {
    this.setState({
      ...this.state,
      existingFilter: [],
      filter: {
        logic: "and",
        filters: [],
      },
    });
  };

  checkRisktypeSelections = (exfilter) => {
    let temp = [];
    this.state.riskTypemaster.map((item) => {
      let checked = this.checkCFinFilterValuesOrNot(
        "riskTypeNames",
        item.hashValue,
        exfilter
      );
      item["checked"] = checked;
      temp.push(item);
    });
    this.setState({ ...this.state, riskTypemaster: temp });
  };

  createDynamicDropdowns = async (products, filter,flag) => {
    try {
      let dropdownColumn = [];
      products.map((res, i) => {
        res.customFields &&
          res.customFields.map((item, j) => {
            if (dropdownColumn.length > 0) {
              if (
                !dropdownColumn.find((cf) => cf.fieldName == item.fieldName)
              ) {
                dropdownColumn.push({
                  fieldName: item.fieldName,
                  data: this.getCustomFieldMasterData(item.fieldName, filter),
                  inputType: this.getInputType(item.fieldName),
                });
              }
            } else {
              dropdownColumn.push({
                fieldName: item.fieldName,
                data: this.getCustomFieldMasterData(item.fieldName, filter),
                inputType: this.getInputType(item.fieldName),
              });
            }
          });
      });

      if (dropdownColumn.length > 0) {
        products.map((res) => {
          dropdownColumn.map((col) => {
            let temp = res.customFields.find(
              (item) => item.fieldName === col.fieldName
            );
            if (temp) {
              if (temp.inputType === "Multi Drop Down") {
                let val = temp.selectedCustomFieldNames
                  ? temp.selectedCustomFieldNames.toString()
                  : "";
                let hashArr = this.stringToHashForCF(val, col.data);
                res[col.fieldName] = hashArr;
              } else if (temp.inputType === "Single Drop Down") {
                let val =
                  temp.selectedCustomFieldNames &&
                  temp.selectedCustomFieldNames.length > 0
                    ? temp.selectedCustomFieldNames.toString()
                    : null;
                res[col.fieldName] = val;
              } else if (temp.inputType === "Free Text") {
                let val =
                  temp.multiText && temp.multiText != ""
                    ? temp.multiText
                    : null;
                res[col.fieldName] = val;
              } else if (temp.inputType === "Numeric") {
                let val =
                  temp.multiText && temp.multiText != ""
                    ? parseInt(temp.multiText)
                    : null;
                res[col.fieldName] = val;
              } else if (temp.inputType === "Date") {
                let val =
                  temp.multiText && temp.multiText != ""
                    ? new Date(temp.multiText)
                    : null;
                res[col.fieldName] = val;
              }
            } else {
              res[col.fieldName] = "";
            }
          });
        });
      }
      let columnsToShow = [];
      if (dropdownColumn.length > 0) {
        columnsToShow = dropdownColumn.map((item) => (
          <Column
            field={item.fieldName}
            title={item.fieldName}
            width="150px"
            editable={false}
            cell={(props) =>
              this.viewMultiselectColsCustomDropdown(props, item)
            }
            columnMenu={(props) => this.getCustomFieldColumnMenu(props, item)}
            filter={this.getCustomFieldFilter(item)}
            headerClassName={
              this.checkItsinFilterOrNot(item.fieldName, filter) ? "active" : ""
            }
          />
        ));
      }
      if (flag === "INIT") {
        this.setState({
          ...this.state,
          dropdownColumns: columnsToShow,
          taskDataList: products,
          taskDataListTemp: products,
        });
      } else {
        this.setState({
          ...this.state,
          dropdownColumns: columnsToShow,
          //   taskDataList: products,
          // taskDataListTemp: products,
        });
      }
      
    } catch (err) {
      console.log(err);
    }
  };

  getCustomFieldFilter = (item) => {
    if (item.inputType === "Multi Drop Down") {
      return "";
    } else if (item.inputType === "Single Drop Down") {
      return "text";
    } else if (item.inputType === "Free Text") {
      return "";
    } else if (item.inputType === "Numeric") {
      return "numeric";
    } else if (item.inputType === "Date") {
      return "date";
    } else {
      return "";
    }
  };

  getCustomFieldColumnMenu = (props, item) => {
    if (item.inputType === "Multi Drop Down") {
      return (
        <CustomFieldSearchMenuForAction
          {...props}
          customFieldsmaster={item.data}
          existingFilter={this.state.existingFilter}
          filterChangeV={this.filterChangeV}
          clearFilter={this.clearFilter}
        />
      );
    } else if (item.inputType === "Single Drop Down") {
      return (
        <ColumnMenuCheckboxFilter
          {...props}
          data={this.state.taskDataList}
          getSelectedColumn={this.getSelectedColumn}
        />
      );
    } else {
      return (
        <ColumnMenuFilterForTask
          {...props}
          getSelectedColumn={this.getSelectedColumn}
        />
      );
    }
  };
  getInputType = (fieldName) => {
    try {
      let arr = this.props.customFieldsmaster?.find(
        (item) => item.fieldName == fieldName
      );
      if (arr) {
        return arr.inputType;
      } else {
        return undefined;
      }
    } catch (err) {
      console.error(err);
    }
  };

  getCustomFieldMasterData = (fieldName, filter) => {
    try {
      let arr = this.props.customFieldsmaster?.filter(
        (item) => item.fieldName == fieldName
      );
      if (arr && arr.length > 0) {
        let temp = [];
        arr[0].cfPossibleValues.map((item, index) => {
          let checked = this.checkCFinFilterValuesOrNot(
            fieldName,
            item.hashValue,
            filter
          );
          temp.push({
            id: index,
            name: item.possibleValues,
            checked: checked,
            hashValue: item.hashValue,
          });
        });
        return temp;
      } else {
        return [];
      }
    } catch (err) {
      return [];
    }
  };

  stringToHashForCF(stringArr, data) {
    let hashArr = [];
    if (stringArr && stringArr.includes(",")) {
      let valArr = stringArr.split(",");
      valArr &&
        valArr.map((item1) => {
          let cfVal = data.find((item) => item.name == item1);
          if (cfVal) {
            hashArr.push(cfVal.hashValue);
          }
        });
    } else {
      let cfVal = data.find((item) => item.name == stringArr);
      if (cfVal) {
        hashArr.push(cfVal.hashValue);
      }
    }
    return hashArr.toString();
  }

  createDynamicCols = async (products, filter) => {
    try {
      let impactMaster = [];
      if (products && products.length > 0) {
        impactMaster = products[0].impactResponse;
      }

      let impactColumn = [];

      products.map((res, i) => {
        if (res.impactResponse) {
          res.impactResponse.map((item, j) => {
            if (impactColumn.length > 0) {
              if (!impactColumn.includes(item.name)) {
                impactColumn.push(item.name);
              }
            } else {
              impactColumn.push(item.name);
            }
          });
        }
      });
      
      if (impactColumn.length > 0) {
        products.map((res) => {
          impactColumn.map((col) => {
            let temp = res.impactResponse.find((item) => item.name === col);
            if (temp) {
              res[col] =
                temp.impactType == "Quantitative" ? temp.value : temp.qValue;
            } else {
              res[col] = undefined;
            }
          });
        });
      }
      let columnsToShow = [];
      if (impactColumn.length > 0) {
        columnsToShow = impactColumn.map((item) => (
          <Column
            field={item}
            title={"Change in " + this.getImpactUnit(item, impactMaster)}
            width="100px"
            editable={false}
            filter={"numeric"}
            cell={(props) => (
              <CurrencyFormat {...props} onEditCell={this.onEditCell} />
            )}
            columnMenu={(props) => (
              <ColumnMenuFilterForTask
                {...props}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            headerClassName={
              this.checkItsinFilterOrNot(item, filter) ? "active" : ""
            }
          />
        ));
      }
      // var taskDataList = products.map((dataItem) =>
      //   Object.assign({ selected: false }, dataItem)
      // );
      this.setState({
        ...this.state,
        impactColumns: columnsToShow,
        taskDataList: products,
        taskDataListTemp: this.props.taskDataListTemp,
        take: Math.round((window.innerHeight - 250) / 35),
        skip: 0,
      });
    } catch (err) {
      console.log(err);
    }
  };
  getImpactUnit = (impact, impactMaster) => {
    var impactTemp = impactMaster.find((item) => item.name == impact);
    var res = impact;
    if (
      impactTemp &&
      impactTemp.name &&
      impactTemp.impactType == "Quantitative"
    ) {
      res = impactTemp.name + " / " + impactTemp.units;
    }
    return res;
  };

  dataStateChange = (event) => {
    // this.setState(this.createAppState(event.dataState));
    // this.props.subTaskFilterQueryGenerator(event.dataState);
  };

  createAppState = (dataState) => {
    if (this.state && this.state.taskDataListTemp) {
      return {
        taskDataList: this.state.taskDataListTemp.slice(0),
        dataState: dataState,
      };
    } else {
      return {
        taskDataList: [],
        dataState: dataState,
      };
    }
  };
  onEditCell = () => {};
  selectionChange = (event) => {
    const data = this.state.taskDataList.map((item) => {
      if (item.taskActionId === event.dataItem.taskActionId) {
        item.selected = !event.dataItem.selected;
      }
      return item;
    });
    this.saveSelectedIds(data);
    this.setState({ data });
  };
  headerSelectionChange = (event) => {
    const checked = event.syntheticEvent.target.checked;
    const data = this.state.taskDataList.map((item) => {
      item.selected = checked;
      return item;
    });
    this.saveSelectedIds(data);
    this.setState({ data });
  };
  saveSelectedIds = (data) => {
    let listOfIds = [];
    for (let row of Object.values(data)) {
      if (row.selected) {
        listOfIds.push(row.taskActionId);
      }
    }
    this.setState({ selectedIds: listOfIds });
    this.props.getSubTaskSelectedIds(listOfIds);
  };
  rowClick = (event) => {
    let last = this.lastSelectedIndex;
    const data = [...this.state.taskDataList];
    const current = data.findIndex((dataItem) => dataItem === event.dataItem);

    if (!event.nativeEvent.shiftKey) {
      this.lastSelectedIndex = last = current;
    }

    if (!event.nativeEvent.ctrlKey) {
      data.forEach((item) => (item.selected = false));
    }
    const select = !event.dataItem.selected;
    for (let i = Math.min(last, current); i <= Math.max(last, current); i++) {
      data[i].selected = select;
    }
    this.setState({ data });
  };

  sortChange = (event) => {
    this.setState({
      taskDataList: this.getProducts(event.sort),
      sort: event.sort,
    });
  };
  pageChange = (event) => {
    this.setState({
      skip: event.page.skip,
      take: event.page.take,
    });
  };
  getProducts = (sort) => {
    return orderBy(this.state.taskDataList, sort);
  };

  viewMultiselectColsRiskType = (event) => {
    let value = event.dataItem[event.field];
    let temp = [];

    if (value && value.includes(",")) {
      let arr = value.split(",");
      arr &&
        arr.map((item1, i) => {
          let originalValue = this.state.riskTypemaster.find(
            (item) => item.hashValue == item1
          );
          if (originalValue) {
            temp.push(originalValue.name);
          }
        });
    } else {
      let originalValue = this.state.riskTypemaster.find(
        (item) => item.hashValue == value
      );
      if (originalValue && originalValue.name != " [blank]") {
        temp.push(originalValue.name);
      }
    }
    return <td title={temp.toString()}>{temp.toString()}</td>;
  };

  viewMultiselectColsCustomDropdown = (event, cfObj) => {
    let data = cfObj.data;
    let value = event.dataItem[event.field];

    if (cfObj && cfObj.inputType === "Multi Drop Down") {
      let temp = [];
      if (value && value.includes(",")) {
        let arr = value.split(",");
        arr &&
          arr.map((item1, i) => {
            let originalValue = data.find((item) => item.hashValue === item1);
            if (originalValue) {
              temp.push(originalValue.name);
            }
          });
      } else {
        let originalValue = data.find((item) => item.hashValue === value);
        if (originalValue && originalValue.name != " [blank]") {
          temp.push(originalValue.name);
        }
      }
      return <td title={temp.toString()}>{temp.toString()}</td>;
    } else if (cfObj && cfObj.inputType === "Single Drop Down") {
      return (
        <td title={value ? value.toString() : ""}>
          {value ? value.toString() : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Free Text") {
      return (
        <td title={value ? value.toString() : ""}>
          {value ? value.toString() : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Numeric") {
      return (
        <td
          title={
            value || value === 0 ? formatNumber(parseInt(value), "##,#") : ""
          }
        >
          {value || value === 0 ? formatNumber(parseInt(value), "##,#") : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Date") {
      return (
        <td title={value ? moment(value).format("DD-MMM-YYYY") : ""}>
          {value ? moment(value).format("DD-MMM-YYYY") : ""}
        </td>
      );
    } else {
      return <td></td>;
    }
  };

  removeExistingFilter = (exi, colname) => {
    try {
    } catch (err) {}
  };

  filterChangeV = async (e, colname) => {
    try {
      let filteredExisting = [];
      if (this.state.existingFilter) {
        filteredExisting = this.state.existingFilter.filter(filter2 => {
          if (filter2.filters) {
            return !filter2.filters.some(innerFilter => innerFilter.field === colname);
          } else {
            return filter2.field !== colname;
          }
        });
      }

      let filter = e ? e.filters : [];
      let temp = [];
      if (filter.length > 0) {
        temp = [
          {
            filters: filter,
            logic: "or",
          },
        ];
      }

      let arr = [...filteredExisting, ...temp];
      const result = filterBy(this.state.taskDataListTemp, arr);
      if (result && result.length > 0) {
        await this.createDynamicDropdowns(result, arr);
        //   await this.createDynamicCols(result,arr);
        // await this.checkRisktypeSelections(arr);
      }
      var taskDataList = result.map((dataItem) =>
        Object.assign({ selected: false }, dataItem)
      );
      this.setState({
        ...this.state,
        taskDataList: taskDataList,
        existingFilter: arr,
        take: Math.round((window.innerHeight - 250) / 35),
        skip: 0,
        sort: [],
        filter: {
          logic: "and",
          filters: arr,
        },
      });
      this.saveSelectedIds([]);
      this.props.subTaskFilterQueryGenerator(arr);
    } catch (err) {
      console.error(err);
    }
  };
  clearFilter = async (e) => {
    try {
      let filter = e ? e : [];
      const result = filterBy(this.state.taskDataListTemp, filter);
      await this.createDynamicDropdowns(result, filter);
      //   await this.createDynamicCols(result,filter);
      //   await this.checkRisktypeSelections(filter);
      var taskDataList = result.map((dataItem) =>
        Object.assign({ selected: false }, dataItem)
      );
      this.setState({
        ...this.state,
        taskDataList: taskDataList,
        existingFilter: filter,
        take: Math.round((window.innerHeight - 250) / 35),
        skip: 0,
        sort: [],
        filter: {
          logic: "and",
          filters: filter,
        },
      });
      this.saveSelectedIds([]);
      this.props.subTaskFilterQueryGenerator(filter);
    } catch (err) {
      console.error(err);
    }
  };

  //trigered from parent
  clearFilterNew = async (e) => {
    try {
      let filter = e ? e : [];
      let exi = await this.changeDateValueFromFilters(filter);
      const result = filterBy(this.state.taskDataListTemp, exi);
      await this.createDynamicDropdowns(result, filter);
      //   await this.createDynamicCols(result,filter);
      //   await this.checkRisktypeSelections(filter);
      var taskDataList = result.map((dataItem) =>
        Object.assign({ selected: false }, dataItem)
      );
      this.setState({
        ...this.state,
        taskDataList: taskDataList,
        existingFilter: filter,
        take: Math.round((window.innerHeight - 250) / 35),
        skip: 0,
        sort: [],
        filter: {
          logic: "and",
          filters: filter,
        },
      });
      this.saveSelectedIds([]);
      this.props.subTaskFilterQueryGenerator(filter);
    } catch (err) {
      console.error(err);
    }
  };

  checkItsinFilterOrNot = (field, exfilter) => {
    let headerClassName = false;
    try {
      if (exfilter) {
        exfilter.map((filter) => {
          if (filter.field === field) {
            headerClassName = true;
          }
          if (filter.filters) {
            filter.filters.map((innerFilter) => {
              if (innerFilter.field === field) {
                headerClassName = true;
              }
            });
          }
        });
        return headerClassName;
      }
    } catch (err) {
      return headerClassName;
    }
  };

  checkCFinFilterValuesOrNot = (field, value, exfilter) => {
    let flag = false;
    try {
      if (exfilter) {
        exfilter.map((filter) => {
          if (filter.field === field && filter.value == value) {
            flag = true;
          }
          if (filter.filters) {
            filter.filters.map((innerFilter) => {
              if (innerFilter.field === field && innerFilter.value == value) {
                flag = true;
              }
            });
          }
        });
      }
    } catch (err) {
      return flag;
    }
    return flag;
  };

  changeDateValueFromFilters = (exfilter) => {
    try {
      if (exfilter) {
        exfilter.map((filter) => {
          let flag = moment(
            filter.value,
            "YYYY-MM-DDTHH:mm:ss",
            true
          ).isValid();
          // if (filter.field === "updatedDate"||
          // filter.field === "createdDate"||
          // filter.field === "actualCompletionDate"||
          // filter.field === "originalCompletionDate" ||
          // filter.field === "projectedCompletionDate"||
          // filter.field === "proximityDate") {
          if (flag) {
            filter["value"] = new Date(filter.value);
          }
          if (filter.filters) {
            filter.filters.map((innerFilter) => {
              let flag = moment(
                innerFilter.value,
                "YYYY-MM-DDTHH:mm:ss",
                true
              ).isValid();

              // if (
              //   innerFilter.field === "updatedDate" ||
              //   innerFilter.field === "createdDate" ||
              //   innerFilter.field === "actualCompletionDate" ||
              //   innerFilter.field === "originalCompletionDate" ||
              //   innerFilter.field === "projectedCompletionDate" ||
              //   innerFilter.field === "proximityDate"
              // ) {
              if (flag) {
                innerFilter["value"] = new Date(innerFilter.value);
              }
            });
          }
        });
        return exfilter;
      }
    } catch (err) {}
    return exfilter;
  };
  filterChangeExisting = async (e) => {
    if (e.nativeEvent.type == "submit") {
      const newFilterFields = new Set();
      let filter = e.filter ? e.filter.filters : [];
      
      if (filter && filter.length > 0) {
        filter.forEach(filterItem => {
          if (filterItem.filters) {
            filterItem.filters.forEach(innerFilter => {
              if (innerFilter.field) {
                newFilterFields.add(innerFilter.field);
              }
            });
          } else if (filterItem.field) {
            newFilterFields.add(filterItem.field);
          }
        });
      }
      
      // Remove any existing filters for the same fields
      let existingFilter = this.state.existingFilter ? this.state.existingFilter : [];
      let filteredExisting = existingFilter.filter(item => {
        // For filters with nested filters array
        if (item.filters) {
          return !item.filters.some(innerFilter =>
            innerFilter.field && newFilterFields.has(innerFilter.field)
          );
        }
        // For direct filters
        return !(item.field && newFilterFields.has(item.field));
      });
      
      let arr = [...filteredExisting, ...filter];
      const result = filterBy(this.state.taskDataListTemp, arr);
      if (result && result.length > 0) {
        await this.createDynamicDropdowns(result, arr);
        //   await this.createDynamicCols(result,arr);
        //   await this.checkRisktypeSelections(arr);
      }
      var taskDataList = result.map((dataItem) =>
        Object.assign({ selected: false }, dataItem)
      );
      this.setState({
        ...this.state,
        taskDataList: taskDataList,
        existingFilter: arr,
        take: Math.round((window.innerHeight - 250) / 35),
        sort: [],
        filter: {
          logic: "and",
          filters: arr,
        },
        skip: 0,
      });
      this.saveSelectedIds([]);
      this.props.subTaskFilterQueryGenerator(arr);
    } else if (e.nativeEvent.type == "reset") {
      let exi = [];
      if (this.state.existingFilter) {
        let filterData = this.state.existingFilter;
        filterData.forEach((filter2) => {
          if (filter2.filters) {
            // Check if any inner filter matches the selected column
            const hasMatchingInnerFilter = filter2.filters.some(
              innerFilter => innerFilter.field === this.state.selectedColumn
            );
            // Only add the filter if none of its inner filters match the selected column
            if (!hasMatchingInnerFilter) {
              exi.push(filter2);
            }
          } else {
            // For direct filters, only add if field doesn't match selected column
            if (filter2.field !== this.state.selectedColumn) {
              exi.push(filter2);
            }
          }
        });
      }
      const result = filterBy(this.state.taskDataListTemp, exi);
      await this.createDynamicDropdowns(result, exi);
      //   await this.createDynamicCols(result,exi);
      //   await this.checkRisktypeSelections(exi);
      var taskDataList = result.map((dataItem) =>
        Object.assign({ selected: false }, dataItem)
      );
      this.setState({
        ...this.state,
        taskDataList: taskDataList,
        existingFilter: exi,
        take: Math.round((window.innerHeight - 250) / 35),
        skip: 0,
        sort: [],
        filter: {
          logic: "and",
          filters: exi,
        },
      });
      this.saveSelectedIds([]);
      this.props.subTaskFilterQueryGenerator(exi);
    }
  };

  getSelectedColumn = (col) => {
    if (col != this.state.selectedColumn) {
      this.setState({ ...this.state, selectedColumn: col });
    }
  };

  removeSelectedFilterInExisting = () => {
    let exi = [];
    if (this.state.existingFilter) {
      let filterData = this.state.existingFilter;
      filterData.map((filter2) => {
        if (filter2.filters) {
          filter2.filters.map((innerFilter) => {
            if (innerFilter.field != this.state.selectedColumn) {
              exi.push(filter2);
            }
          });
        } else {
          if (filter2.field != this.state.selectedColumn) {
            exi.push(filter2);
          }
        }
      });
    }
    return exi;
  };

  setClassName = (field) => {
    let headerClassName = "";
    if (this.state.filter && this.state.filter.filters) {
      this.state.filter.filters.map((filter) => {
        if (filter.field === field) {
          headerClassName = "active";
        }
        if (filter.filters) {
          filter.filters.map((innerFilter) => {
            if (innerFilter.field === field) {
              headerClassName = "active";
            }
          });
        }
      });
    }
    return headerClassName;
  };

//Triggred by parent
getTaskActionDatasetView =async (datasetObj) => {
  try {
    this.setState({
      ...this.state,
      loader: true,
      customFieldsmaster: this.props.customFieldsmaster,
      taskDataList: [],
      taskDataListTemp: [],
    });
    var request = {
      viewId:datasetObj.id,
      CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
    };
    let result = await Api.getTaskActionDatasetView(request);
   if (result.status === 200) {
   
           if (
             result.isCustomFieldDeleted ||
             result.isImpactDeleted ||
             result.notValidPrimeDataset
           ) {
             this.setState({
               ...this.state,
               selectedOrgUnit: [],
               OrgUnitIds: [],
               isCustomFieldDeleted: result.isCustomFieldDeleted,
               isImpactDeleted: result.isImpactDeleted,
               notValidPrimeDataset: result.notValidPrimeDataset,
               isSelectAllWorkstream: result.isSelectAllWorkstream,
               loader: false,
             });
             return;
           }
           let response = await this.getTaskActionsByWorkstreamId(result.orgUnitIds);
           var selectedOrgUnitArray = [];
           response.taskActions.map((riskReg) => {
           
             if (riskReg.originalCompletionDate) {
               riskReg.originalCompletionDate =new Date(riskReg.originalCompletionDate); //riskReg.originalCompletionDate? moment(new Date(riskReg.originalCompletionDate)).format("DD-MMM-YYYY"):null;
             }
             if (riskReg.projectedCompletionDate) {
               riskReg.projectedCompletionDate =new Date(riskReg.projectedCompletionDate);//riskReg.projectedCompletionDate? moment(new Date(riskReg.projectedCompletionDate)).format("DD-MMM-YYYY"):null;
             }
             if (riskReg.actualCompletionDate) {
               riskReg.actualCompletionDate =new Date(riskReg.actualCompletionDate);//riskReg.actualCompletionDate? moment(new Date(riskReg.actualCompletionDate)).format("DD-MMM-YYYY"):null;
             }
             if (riskReg.proximityAlertDate) {
               riskReg.proximityAlertDate = new Date(riskReg.proximityAlertDate);//riskReg.proximityAlertDate? moment(new Date(riskReg.proximityAlertDate)).format("DD-MMM-YYYY"):null;
             }
             if (riskReg.updatedDate) {
               var time = moment(riskReg.updatedDate).toDate();
               time.setHours(0);
               time.setMinutes(0);
               time.setSeconds(0);
               time.setMilliseconds(0);
               let updatedDate = time;
               riskReg.updatedDate = riskReg.updatedDate
                 ? new Date(updatedDate)
                 : "";
             }
             if (riskReg.createdDate) {
               let time = moment(riskReg.createdDate).toDate();
               time.setHours(0);
               time.setMinutes(0);
               time.setSeconds(0);
               time.setMilliseconds(0);
               let createdDate = time;
               riskReg.createdDate = riskReg.createdDate
                 ? new Date(createdDate)
                 : "";
             }
             if (riskReg.closedDate) {
               let time = moment(riskReg.closedDate).toDate();
               time.setHours(0);
               time.setMinutes(0);
               time.setSeconds(0);
               time.setMilliseconds(0);
               let closedDate = time;
               riskReg.closedDate = riskReg.closedDate
                 ? new Date(closedDate)
                 : "";
             }
             
             selectedOrgUnitArray.push(riskReg.organizationUnitId);
   
             if (riskReg.isClosed===false) {
               riskReg.isClosed = "Open";
             } else {
               riskReg.isClosed = "Closed";
             }
             if (riskReg.isApproved===false) {
               riskReg.isApproved = "No";
             } else {
               riskReg.isApproved = "Yes";
             }
           });
           
            await this.createDynamicDropdowns(response.taskActions);
            this.setState({
              ...this.state,
              loader: false,
              selectedOrgUnit: selectedOrgUnitArray,
              OrgUnitIds: Array.from(new Set(selectedOrgUnitArray)),
              taskDataList: response.taskActions,
              taskDataListTemp: response.taskActions,
              isCustomFieldDeleted: result.isCustomFieldDeleted,
              isImpactDeleted: result.isImpactDeleted,
              notValidPrimeDataset: result.notValidPrimeDataset,
              isSelectAllWorkstream: result.isSelectAllWorkstream,
              sort: [],
              filter: {
                logic: "and",
                filters: [],
              },
            });
            //Filter
           if (result.isFiltered && result.filterQuery) {
             let parsedData = JSON.parse(result.filterQuery);
             if (parsedData && parsedData !== "{}") {
               let val = JSON.parse(parsedData);
               await this.clearFilterNew(val);
             } else {
               this.setState(
                 {
                   ...this.state,
                   taskDataList: response.taskActions,
                   isSelectAllWorkstream: result.isSelectAllWorkstream,
                 },
                 () => {
                   console.log("-");
                 }
               );
             }
           }
           //CheckBox
           var taskData = [];
           if (!result.isFiltered) {
             result.taskActions.map((_task) => {
               let index = this.state.taskDataList.findIndex(
                 (d) => d.taskActionId === _task.taskActionId
               );
               if (index != -1) {
                 taskData.push(this.state.taskDataList[index]);
               }
             });
             taskData = taskData.map((dataItem) =>
               Object.assign({ selected: true }, dataItem)
             );
           } else {
             taskData = this.state.taskDataList;
           }
           this.setState({
             ...this.state,
             taskDataList: taskData,
             isSelectAllWorkstream: result.isSelectAllWorkstream,
           });
            this.props.workstreamIdpopulation(Array.from(new Set(selectedOrgUnitArray)));
   
         } else {
           this.initSubTasks([]);
           this.props.workstreamIdpopulation([]);
           this.setState({ ...this.state, 
             loader: false,
             taskDataList: [],
             taskDataListTemp: [] });
         }
         //Top-X
         // dynamicdatset-modification in if condition
   
         if (
           (result.isFiltered &&
             datasetObj.field &&
             datasetObj.topOrBottom &&
             datasetObj.topOrBottomCount) ||
           (datasetObj.topxDateMode &&
             datasetObj.topxDateField &&
             datasetObj.topxDateCount)||
             (datasetObj.topxDateMode &&
               datasetObj.topxDateField &&
               datasetObj.topxDateCount===0)
         ) {
           let tempResult = [];
           if (
             result.taskActions &&
             result.taskActions.length > 0 &&
             this.state.taskDataList.length > 0
           ) {
             result.taskActions.map((_task) => {
               let index = this.state.taskDataList.findIndex(
                 (d) => d.taskActionId === _task.taskActionId
               );
               if (index != -1) {
                 tempResult.push(this.state.taskDataList[index]);
               }
             });
           }
           this.setState({
             ...this.state,
             taskDataList: tempResult,
             isSelectAllWorkstream: result.isSelectAllWorkstream,
           });
           setTimeout(() => {
             this.setState({
               ...this.state,
               loader: false,
               isSelectAllWorkstream: result.isSelectAllWorkstream,
             });
           }, 1000);
         } else {
           setTimeout(() => {
             this.setState({
               ...this.state,
               loader: false,
               isSelectAllWorkstream: result.isSelectAllWorkstream,
   
             });
           }, 1000);
         }
  } catch (err) {
    this.setState({ ...this.state, 
      loader: false,
      taskDataList: [],
      taskDataListTemp: []
     });
  }
};

 getTaskActionsByWorkstreamId =async(idList)=>{
    try{
      var request = {
        workstreamIds: idList,
      };
      let response = await Api.getTaskActionsByWorkstreamId(request);
      if (response.status === 200) {
        return response;
      } else {
        return [];
      }
    }catch(err){
      console.error(err);
      return [];
    }
  }
  progressHistory = (dataItem) => {
    this.setState({ ...this.state, progressStatusFlag: true,actionProgressComments: dataItem.actionProgressComments});
  };

  closeProgressHistoryPopup = () => {
    this.setState({ ...this.state, progressStatusFlag: false,actionProgressComments: []});
  };
  render() {
    return (
      <div className="riskViewCont">
        <div
          className="tblCont riskRegister dataGrids ActionTbl"
          id="datasetaction"
        >
          {this.state.loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}
          <Grid
            data={filterBy(this.state.taskDataList, this.state.filter).slice(
              this.state.skip,
              this.state.take + this.state.skip
            )}
            {...this.state.dataState}
            onDataStateChange={this.dataStateChange}
            selectedField="selected"
            onSelectionChange={this.selectionChange}
            onHeaderSelectionChange={this.headerSelectionChange}
            // onRowClick={this.rowClick}
            filterOperators={filterOperators}
            reorderable={this.state.taskDataList.length == 0 ? false : true}
            resizable={this.state.taskDataList.length == 0 ? false : true}
            pageable={true}
            // total={this.state.taskDataList.length}
            sortable={{
              allowUnsort: true,
              mode: "multiple",
            }}
            sort={this.state.sort}
            onSortChange={this.sortChange}
            total={filterBy(this.state.taskDataList, this.state.filter).length}
            skip={this.state.skip}
            take={this.state.take}
            onPageChange={this.pageChange}
            onFilterChange={this.filterChangeExisting}
            filter={this.state.filter}
          >
            <GridNoRecords>
              {this.props.isCustomFieldDeleted
                ? "Associated Dataset's Custom fields might been deleted or revoked"
                : this.props.isImpactDeleted
                ? "Associated Dataset's Impact fields might been deleted or revoked"
                : "No records available"}
            </GridNoRecords>
            <Column
              field="selected"
              locked={true}
              width="42px"
              headerSelectionValue={
                this.state.taskDataList.findIndex(
                  (dataItem) => dataItem.selected === false
                ) === -1
              }
            />
            <Column
              field="organizationUnitName"
              title="Workstream"
              width="200px"
              columnMenu={(props) => (
                <ColumnMenuFilterForTask
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("organizationUnitName")}
            />
            <Column
              field="taskNumber"
              title="Task Number"
              width="200px"
              columnMenu={(props) => (
                <ColumnMenuFilterForTask
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("taskNumber")}
            />
            <Column
              field="taskDescription"
              title="Task Description"
              width="200px"
              columnMenu={(props) => (
                <ColumnMenuFilterForTask
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("taskDescription")}
            />
            <Column
              field="taskActionNumber"
              title="Activity Number"
              width="200px"
              columnMenu={(props) => (
                <ColumnMenuFilterForTask
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("taskActionNumber")}
            />
            <Column
              field="isApproved"
              title="Approved"
              width="200px"
              columnMenu={(props) => (
                <ColumnMenuCheckboxFilter
                  {...props}
                  data={this.state.taskDataList}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("isApproved")}
            />
            <Column
              field="taskActionTitle"
              title="Activity Title"
              width="200px"
              columnMenu={(props) => (
                <ColumnMenuFilterForTask
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("taskActionTitle")}
            />
            <Column
              field="taskActionDescription"
              title="Activity Description"
              width="200px"
              columnMenu={(props) => (
                <ColumnMenuFilterForTask
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("taskActionDescription")}
            />
            <Column
              field="cost"
              title={
                "Cost of Activity" +
                " (" +
                secureLocalStorage.getItem("currency") +
                ")"
              }
              width="200px"
              filter={"numeric"}
              columnMenu={(props) => (
                <ColumnMenuFilterForTask
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("cost")}
            />
            <Column
              field="effort"
              title={"Effort" + " (Days)"}
              width="200px"
              filter={"numeric"}
              columnMenu={(props) => (
                <ColumnMenuFilterForTask
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("effort")}
            />
            <Column
              field="percentageOnTrack"
              title="% on Track"
              width="200px"
              filter={"numeric"}
              columnMenu={(props) => (
                <ColumnMenuFilterForTask
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("percentageOnTrack")}
            />
            <Column
              field="percentageCompletion"
              title="% Completion"
              width="200px"
              filter={"numeric"}
              columnMenu={(props) => (
                <ColumnMenuFilterForTask
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("percentageCompletion")}
            />
            <Column
              field="priorityRankingName"
              title="Priority Ranking"
              width="200px"
              columnMenu={(props) => (
                <ColumnMenuCheckboxFilter
                  {...props}
                  data={this.state.taskDataList}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("priorityRankingName")}
            />
            <Column
              field="priorityScore"
              title="Weighted Priority"
              width="200px"
              filter={"numeric"}
              columnMenu={(props) => (
                <ColumnMenuFilterForTask
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("priorityScore")}
            />
            <Column
              field="progressComment"
              title="progress Status"
              width="200px"
              cell={(props) => (
                <td title={props.dataItem.progressComment}>
                  <span onClick={() => this.progressHistory(props.dataItem)}>
                    {props.dataItem.progressComment}
                  </span>
                </td>
              )}
              // columnMenu={(props) => (
              //   <ColumnMenuFilterForTask
              //     {...props}
              //     getSelectedColumn={this.getSelectedColumn}
              //   />
              // )}
              // headerClassName={this.setClassName("progressComment")}
            />
            {this.state.dropdownColumns}
            <Column
              field="originalCompletionDate"
              title="Original Completion Date"
              width="200px"
              filter={"date"}
              format="{0:dd-MMM-yyyy}"
              columnMenu={(props) => (
                <ColumnMenuFilterForTask
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              cell={(props) => (
                <TaskOriginalCompDate {...props} onEditCell={this.onEditCell} />
              )}
              headerClassName={this.setClassName("originalCompletionDate")}
            />
            <Column
              field="projectedCompletionDate"
              title="Projected Completion Date"
              width="200px"
              filter={"date"}
              format="{0:dd-MMM-yyyy}"
              columnMenu={(props) => (
                <ColumnMenuFilterForTask
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              cell={(props) => (
                <TaskProjectedComDate {...props} onEditCell={this.onEditCell} />
              )}
              headerClassName={this.setClassName("projectedCompletionDate")}
            />
            <Column
              field="actualCompletionDate"
              title="Actual Completion Date"
              width="200px"
              filter={"date"}
              format="{0:dd-MMM-yyyy}"
              columnMenu={(props) => (
                <ColumnMenuFilterForTask
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("actualCompletionDate")}
            />
            <Column
              field="proximityAlertDate"
              title="Proximity Alert Date"
              width="200px"
              filter={"date"}
              format="{0:dd-MMM-yyyy}"
              columnMenu={(props) => (
                <ColumnMenuFilterForTask
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("proximityAlertDate")}
            />
            <Column
              field="daysOverdue"
              title="Original Days Overdue"
              width="120px"
              editable={false}
              filter={"numeric"}
              columnMenu={(props) => (
                <ColumnMenuFilterForTask
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("daysOverdue")}
            />
            <Column
              field="projectedDaysOverdue"
              title="Projected Days Overdue"
              width="120px"
              editable={false}
              filter={"numeric"}
              columnMenu={(props) => (
                <ColumnMenuFilterForTask
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("projectedDaysOverdue")}
            />
            {/* <Column
              field="delayConsequence"
              title="Delay Consequence"
              width="200px"
              columnMenu={(props) => (
                <ColumnMenuFilterForTask
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("delayConsequence")}
            />
            <Column
              field="alertStakeHolders"
              title="Alert Stakeholders"
              width="200px"
              columnMenu={(props) => (
                <ColumnMenuFilterForTask
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("alertStakeHolders")}
            />
            <Column
              field="alertDescription"
              title="Alert Description"
              width="200px"
              columnMenu={(props) => (
                <ColumnMenuFilterForTask
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("alertDescription")}
            /> */}
            <Column
              field="ownerName"
              title="Activity Owner"
              width="200px"
              columnMenu={(props) => (
                <ColumnMenuCheckboxFilter
                  {...props}
                  data={this.state.taskDataList}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("ownerName")}
            />
            <Column
              field="taskActionFieldCompletion"
              title="% of fields completed"
              width="120px"
              editable={false}
              filter={"numeric"}
              columnMenu={(props) => (
                <ColumnMenuFilterForTask
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("taskActionFieldCompletion")}
            />
            <Column
              field="createdDate"
              title="Created Date"
              width="200px"
              filter={"date"}
              format="{0:dd-MMM-yyyy}"
              columnMenu={(props) => (
                <ColumnMenuFilterForTask
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("createdDate")}
            />
            <Column
              field="createdByName"
              title="Created By"
              width="200px"
              columnMenu={(props) => (
                <ColumnMenuCheckboxFilter
                  {...props}
                  data={this.state.taskDataList}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("createdByName")}
            />
            <Column
              field="updatedDate"
              title="Updated Date"
              width="200px"
              filter={"date"}
              format="{0:dd-MMM-yyyy}"
              columnMenu={(props) => (
                <ColumnMenuFilterForTask
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("updatedDate")}
            />
            <Column
              field="updatedByName"
              title="Updated By"
              width="200px"
              columnMenu={(props) => (
                <ColumnMenuCheckboxFilter
                  {...props}
                  data={this.state.taskDataList}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("updatedByName")}
            />
            <Column
              field="closedDate"
              title="Closed Date"
              width="200px"
              filter={"date"}
              format="{0:dd-MMM-yyyy}"
              columnMenu={(props) => (
                <ColumnMenuFilterForTask
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("closedDate")}
            />
            <Column
              field="isClosed"
              title="Status"
              width="200px"
              columnMenu={(props) => (
                <ColumnMenuCheckboxFilter
                  {...props}
                  data={this.state.taskDataList}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("isClosed")}
            />

            <Column
              field="departments"
              title="Departments"
              width="150px"
              columnMenu={(props) => (
                <ColumnMenuFilterForTask
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("departments")}
            />
            <Column
              field="externalStatus"
              title="External Status"
              width="120px"
              columnMenu={(props) => (
                <ColumnMenuFilterForTask
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("externalStatus")}
            />
            <Column
              field="weeklyReport"
              title="Weekly Report"
              width="100px"
              columnMenu={(props) => (
                <ColumnMenuFilterForTask
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("weeklyReport")}
            />
          </Grid>
        </div>
        <Popup
                        show={this.state.progressStatusFlag}
                        popupClass={"popup-content popup-wrapper"}
                      >
                        <div className="deleteModelCont stackHolderSelection">
                          <label className="fieldLabel">Progress History</label>
                          <div className="commentsHistory">
                            <ul className="comments">
                              {this.state.actionProgressComments &&
                                this.state.actionProgressComments.map((item) => (
                                  <li>
                                    <p>{item.taskActionComment}</p>
                                    <small>
                                      Date:
                                      {moment(new Date(item.createdDate)).format(
                                        "DD-MMM-yyyy HH:mm:ss"
                                      )}
                                    </small>{" "}
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                                    <small>Entered by:{item.userName}</small>
                                  </li>
                                ))}
                            </ul>
                          </div>
                          <div className="progressBtn">
                            <button
                              onClick={this.closeProgressHistoryPopup}
                              className="redbtn"
                              type="button"
                              style={{ "margin-left": "700px", "margin-bottom": "15px" }}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </Popup>
      </div>
    );
  }
}
